(function () {
  'use strict';

  /* mr-selleasy-presentation.js -- REVEAL-ON-CONTENT ONLY.

     Redesign attempts (compact horizontal cards) were reverted twice: both the
     full-card <label> overlay AND the tick-only (restyled checkbox) versions
     stopped Selleasy's live-total from recalculating when a card is deselected
     (verified live: tapping the tick unchecked the item but the total stayed
     put). Preserving the live total + Add All to Cart is non-negotiable, and
     Selleasy's recalc cannot be driven from presentation-only theme code, so
     the widget is restored to Selleasy's own rendering.

     #mr-selleasy-shell carries a top hairline + padding (in
     mr-t-product-stage-e.css) only once Selleasy's relocated widget actually
     has content. Selleasy's widget is gated behind a real scroll/intersection
     trigger (content can arrive seconds-to-minutes into a visit, or never), so
     the observer is left attached for the page lifetime and disconnects itself
     the moment content appears. Never touches Selleasy's widget internals. */

  var SHELL_ID = 'mr-selleasy-shell';
  var WIDGET_SELECTOR = 'lb-product-page-cross-sell-ew';
  var HAS_CONTENT_CLASS = 'mr-s-product-commitment__selleasy-shell--has-content';

  function hasRealContent(widget) {
    return !!widget && widget.innerHTML.trim().length > 0;
  }

  function checkAndReveal(shell) {
    var widget = shell.querySelector(WIDGET_SELECTOR);
    if (hasRealContent(widget)) {
      shell.classList.add(HAS_CONTENT_CLASS);
      return true;
    }
    return false;
  }

  function init() {
    var shell = document.getElementById(SHELL_ID);
    if (!shell) return;
    if (checkAndReveal(shell)) return;

    var observer = new MutationObserver(function () {
      if (checkAndReveal(shell)) {
        observer.disconnect();
      }
    });
    observer.observe(shell, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MRSelleasyPresentation = { init: init };
})();
